(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Scrolling-text-image"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '.cb-index-section-partner-wrap';
    const trackSelector =
      '.cb-index-section-partner__desktop-wrap.is-animated, .cb-index-section-partner__mobile-item-wrap.is-animated';

    const stripEditorAttributes = (node) => {
      const elements = [node, ...node.querySelectorAll('*')];

      elements.forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) {
            element.removeAttribute(attribute.name);
          }
        });
      });
    };

    const createGeneratedItem = (item) => {
      const clone = item.cloneNode(true);
      clone.dataset.cbMarqueeGenerated = 'true';
      clone.setAttribute('aria-hidden', 'true');
      stripEditorAttributes(clone);
      return clone;
    };

    const fillTrack = (track) => {
      const viewport = track.parentElement;
      const viewportWidth = viewport.clientWidth;

      if (viewportWidth === 0) {
        return;
      }

      const groups = Array.from(track.children).filter((element) => {
        return (
          element.classList.contains('cb-index-section-partner__desktop-group') ||
          element.classList.contains('cb-index-section-partner__mobile-group')
        );
      });

      if (groups.length < 2) {
        return;
      }

      const firstGroup = groups[0];
      const secondGroup = groups[1];

      Array.from(firstGroup.children).forEach((item) => {
        if (item.dataset.cbMarqueeGenerated === 'true') {
          item.remove();
        }
      });

      const sourceItems = Array.from(firstGroup.children);

      if (sourceItems.length === 0) {
        return;
      }

      track.style.animation = 'none';

      let previousWidth = firstGroup.scrollWidth;
      let pass = 0;

      while (firstGroup.scrollWidth < viewportWidth && pass < 30) {
        const fragment = document.createDocumentFragment();

        sourceItems.forEach((item) => {
          fragment.appendChild(createGeneratedItem(item));
        });

        firstGroup.appendChild(fragment);
        pass += 1;

        if (firstGroup.scrollWidth <= previousWidth) {
          break;
        }

        previousWidth = firstGroup.scrollWidth;
      }

      const secondFragment = document.createDocumentFragment();

      Array.from(firstGroup.children).forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        stripEditorAttributes(clone);
        secondFragment.appendChild(clone);
      });

      secondGroup.replaceChildren(secondFragment);
      track.offsetHeight;
      track.style.animation = '';
    };

    const init = (scope = document) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const roots = scope.matches?.(rootSelector)
        ? [scope]
        : Array.from(scope.querySelectorAll(rootSelector));

      roots.forEach((root) => {
        root.querySelectorAll(trackSelector).forEach(fillTrack);
      });
    };

    if (window.cbPartnerMarquee) {
      window.cbPartnerMarquee.init(document);
      return;
    }

    window.cbPartnerMarquee = { init };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => init(document));
    }

    let resizeTimer;

    window.addEventListener(
      'resize',
      () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => init(document), 150);
      },
      { passive: true }
    );

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
